<template>
    <div>ai</div>
</template>

<script>
export default {};
</script>

<style>
</style>